import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getConflictRoles = async (token, municipality_id, params) => {
  const url = `municipalities/${municipality_id}/conflicts/${params.conflict_id}/roles`
  const data = await apiGet({ url, token, params })
  return data
}

export function useConflictRoles({ params, options = {} }) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)

  const queryFn = () => getConflictRoles(token, municipality_id, params)
  const queryKey = ['conflictRoles', params]
  return useQuery(queryKey, queryFn, { ...options })
}